import React from "react";
import { inject, observer } from "mobx-react";
import HomePageStore from "../HomePageStore";
import ReactDOM from "react-dom";
import ImgLazyLoad from "../../ImgLazyLoad";

interface homePageBannerProps {}

interface InjectedProps extends homePageBannerProps {
  homePageStore: HomePageStore;
}

class homePageBanner extends React.Component<homePageBannerProps> {

  render() {
    const { homePageStore } = this.props as InjectedProps;
    const { banner } = homePageStore.homePageContent.response;
    return (
      <div>
        <div id="home_Page_Banner" className="modelHeroImg subaru_banner">
          <a href={banner.bannerHyperLink}>
            <ImgLazyLoad
              className="modelHeroImg__img modelHeroImg__img--xs"
              src={banner.bannerImage_XS}
            />
            <ImgLazyLoad
              className="modelHeroImg__img modelHeroImg__img--sm"
              src={banner.bannerImage_SM}
            />
            <ImgLazyLoad
              className="modelHeroImg__img modelHeroImg__img--lg"
              src={banner.bannerImage_LG}
            />
            <ImgLazyLoad
              className="modelHeroImg__img modelHeroImg__img--xl"
              src={banner.bannerImage_XL}
            />
          </a>
        </div>
        <div className="subaru_banner_text_wrapper">
          <div className="container">
            <div
              className="subaru_banner_text"
              dangerouslySetInnerHTML={{
                __html: banner.bannerIntro,
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default inject("homePageStore")(observer(homePageBanner));
